import { ExternalCalendar } from './external-calendar';
import { ID } from './id';

export enum ViewOptionsSectionId {
  Show = 'show',
  LifeAreas = 'life-areas',
}

export type ViewOptionsCalendarAccount = {
  id: ID;
  title: string;
  calendars: ExternalCalendar[];
};

export type ViewOptionsSectionEntry = {
  id: ID;
  // Only a calendar-account entry carries data; the fixed sections source their own.
  account?: ViewOptionsCalendarAccount;
};
